import { UsePlanAnualContext } from "#training/contexts/AnnualPlanCreateContext"
import { Box, Button, Paper, Stack } from "@mui/material"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import { toast } from "react-toastify"
import SelectCourse from "../SelectCourse"
import AnnualPlanCreateListaDrop from "./AnnualPlanCreateListaDrop"

export default function AnnualPlanCreateCursos({ areas = [] }) {
	const { selectAreas } = UsePlanAnualContext()
	if (!selectAreas.length) return null

	return (
		<Box component={Paper} p={2} gap={5} display="flex" flexDirection="column">
			<SelectCursos />
			<AnnualPlanCreateListaDrop />
		</Box>
	)
}

const SelectCursos = () => {
	const { cursosIds, setCursosIds, cursos } = UsePlanAnualContext()
	const [select, setSelect] = useState("")
	const handleSelect = () => {
		if (!cursosIds.includes(select)) setCursosIds((old) => [...old, select])
		else toast.error("Curso ya seleccionado")
		setSelect("")
	}

	if (cursosIds.length === 12) return null

	return (
		<Stack spacing={2} justifyItems={"center"} alignItems={"center"}>
			<Typography variant="poster" component="h2" align="center">
				Selecciona Curso
			</Typography>

			<SelectCourse
				data={cursos.filter((item) => !cursosIds.includes(item.id))}
				fullWidth
				value={select}
				setValue={(curso) => setSelect(curso)}
			/>
			<Button onClick={handleSelect}>Agregar Curso</Button>
		</Stack>
	)
}
